import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-edit',
  imports: [],
  templateUrl: './icon-bold-edit.html',
  standalone: true,
  styleUrl: './icon-bold-edit.css'
})
export class IconBoldEdit {
    @Input() color: string = '#292D32';
    @Input() size: string = '24px';
}
